import React from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';

import fieldRequired from '../../../validators/fieldRequired';
import FolderStructure from '../../FolderStructure';
import IconTooltip from '../../IconTooltip';
import { H5, Paragraph } from '../../Typography';
import { useUploadDocumentContext } from '../context';

import styles from '../UploadDocumentModal.module.scss';

const DestinationStep = ({ form }) => {
  const { folderData } = useUploadDocumentContext();
  return (
    <div className={styles.uploadedState}>
      <div className={styles.documentTitle}>
        <div className={styles.wrapper}>
          <H5>Destination folder</H5>
          <IconTooltip
            icon="info"
            size="md"
            className={styles.iconTooltip}
            tooltipClassName={styles.tooltip}
            tip={
              <ul className={styles.tooltipText}>
                <li>
                  {' '}
                  <b>Lease Documents:</b> Stores tenant-viewable documents for
                  specific rental periods.
                </li>
                <li>
                  {' '}
                  <b>Property Documents:</b> Stored at the property or unit
                  level and not visible to tenants.
                </li>
                <li>
                  {' '}
                  <b>‘My Documents’:</b> Your private documents not connected to
                  a property or lease.
                </li>
              </ul>
            }
          />
        </div>
        <Paragraph className={styles.destinationDescription}>
          We've created folders based on the active rentals and leases you have
          within your account today.
        </Paragraph>
        <div className={styles.folders}>
          <Field
            component={FolderStructure}
            name="destination"
            id="destination"
            validate={fieldRequired}
            className={styles.folders}
            folderData={folderData}
            onChange={(value) => {
              form.change('destination', value);
            }}
          />
        </div>
      </div>
    </div>
  );
};

DestinationStep.propTypes = {
  form: PropTypes.object,
};

export default DestinationStep;
